import React, { useEffect, useState } from "react";
import BreadCrumbBar from "../../common/breadCrumbBar/BreadCrumbBar";
import "../../css/common.css";
import { DataGrid } from "@mui/x-data-grid";
import SearchBar from "../../common/searchBar/SearchBar";
import ExportExcel from "../../common/excel/ExportExcel";
import moment from "moment";
import { ApiService } from "../../services/apiService";
import { CircularProgress } from "@mui/material";
import { dateFormat } from "../../common";
import Warning from "../../common/alert/Warning";

export default function LocActionList() {
  const [rowData, setRowData] = useState([]);
  let params = "";
  const [containData, setContainData] = useState({});
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowCount, setRowCount] = useState(0);
  const [excelClick, setExcelClick] = useState(false);
  const [excelList, setExcelList] = useState([]);
  const [totalLength, setTotalLength] = useState(0);
  const [loading, setLoading] = useState(false);

  const [openWarning, setOpenWarning] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 30,
  });

  const closeWarning = (data) => {
    setOpenWarning(data);
  };

  const xlsxHeader = {
    header: [
      "target",
      "수집방법",
      "서비스유형",
      "제공자",
      "제공시간",
      "취득경로",
      "제공방법",
    ],
  };

  const today = moment().format("YYYY-MM-DD");
  const xlsxFileName = "위치정보제공이력리스트_" + today;

  const getExcelData = async () => {
    setExcelClick(false);
    setLoading(true);
    params = `limit=${totalLength}`;

    try {
      const response = await ApiService.getLocationAction(params);
      const excelRows = response.data.datas.map((data) => {
        data.provide_tm = dateFormat(new Date(data.provide_tm));
        return {
          target: data.target,
          수집방법: data.collect_path,
          서비스유형: data.service_type,
          제공자: data.provide_to,
          제공시간: data.provide_tm,
          취득경로: data.provide_comp,
          제공방법: data.provide_path,
        };
      });
      setExcelClick(true);
      setExcelList(excelRows);
    } catch (error) {
      console.log("LocActionList - getExcelData - error :: ", error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      field: "provide_to",
      headerName: "사용자(제공받은자)",
      minWidth: 200,
      flex: 2,
    },
    {
      field: "collect_path",
      headerName: "수집방법",
      minWidth: 120,
      flex: 0.5,
    },
    {
      field: "service_type",
      headerName: "서비스유형",
      minWidth: 150,
      flex: 0.5,
    },
    {
      field: "provide_tm",
      headerName: "제공일자",
      minWidth: 180,
      flex: 1,
    },
    {
      field: "target",
      headerName: "제공내역",
      minWidth: 200,
      flex: 2,
    },
    {
      field: "provide_comp",
      headerName: "취득경로",
      minWidth: 150,
      flex: 0.5,
    },
    {
      field: "provide_path",
      headerName: "제공방법",
      minWidth: 150,
      flex: 0.5,
    },
  ];

  const options = [
    {
      value: "none",
      item: "검색할 항목 선택",
    },
    {
      value: "provide_to",
      item: "사용자",
    },
    {
      value: "collect_path",
      item: "수집방법",
    },
    {
      value: "service_type",
      item: "서비스유형",
    },
  ];

  const getLocActionList = async (
    limit,
    page,
    containData,
    startTime,
    endTime
  ) => {
    if (startTime !== null && endTime !== null) {
      params = `limit=${limit}&offset=${limit * page}&contains=${JSON.stringify(
        containData
      )}&stime=${startTime}&etime=${endTime}`;
    } else {
      params = `limit=${limit}&offset=${limit * page}&contains=${JSON.stringify(
        containData
      )}`;
    }

    try {
      setLoading(true);
      const locList = await ApiService.getLocationAction(params);
      //엑셀 출력 시 전체 리스트를 조회해야되기 때문
      if (
        JSON.stringify(containData) === "{}" &&
        startTime === null &&
        endTime === null
      ) {
        setTotalLength(locList.data.total);
      }

      const rows = locList.data.datas.map((data) => {
        // data.created = data.created.split('T')[0]
        data.provide_tm = dateFormat(new Date(data.provide_tm));
        data.provide_comp = "(주)파인디지털";
        data.provide_path = "App화면 제공";
        return data;
      });

      setRowData(rows);
      setRowCount(locList.data.total);
    } catch (error) {
      console.log("LocActionList - getLocActionList - error :: ", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    //작업일자 검색할 경우
    if (startDate !== null && endDate !== null) {
      //let timestampSecond = Math.floor(+ new Date("2022-10-23") / 1000)
      let startTime = Math.floor(new Date(startDate + " 00:00:00") / 1000);
      let endTime = Math.floor(new Date(endDate + " 23:59:59") / 1000);
      getLocActionList(
        paginationModel.pageSize,
        paginationModel.page,
        containData,
        startTime,
        endTime
      );
    } else {
      getLocActionList(
        paginationModel.pageSize,
        paginationModel.page,
        containData,
        null,
        null
      );
    }
  }, [paginationModel.page, containData, startDate, endDate]);

  const getData = (selectValue, inputValue, start, end) => {
    const firstDate = moment(start);
    const secondDate = moment(end);
    const diffDay = moment.duration(secondDate.diff(firstDate)).asDays();

    if (selectValue === "none" && inputValue !== "") {
      setOpenWarning(true);
      setErrorMsg("검색할 항목을 선택하세요!");
    } else {
      if (
        (start === null && end !== null) ||
        (start !== null && end === null) ||
        diffDay < 0
      ) {
        setOpenWarning(true);
        setErrorMsg("정확한 기간을 선택해주세요.");
      } else if (diffDay > 30) {
        setOpenWarning(true);
        setErrorMsg("조회 기간을 1개월(30일) 단위로 설정해주세요.");
      } else {
        setStartDate(start);
        setEndDate(end);

        if (inputValue === "") {
          setContainData({});
        } else {
          setContainData({ [selectValue]: inputValue.trim() });
        }
      }
    }
  };

  return (
    <div className="containList">
      <BreadCrumbBar menu="이력 관리" smenu="위치정보제공 이력 조회" />

      <div className="containItem">
        <div className="excelBtn" onClick={getExcelData}>
          <ExportExcel
            excelClick={excelClick}
            header={xlsxHeader}
            excelData={excelList}
            fileName={xlsxFileName}
          />
        </div>
        <SearchBar options={options} getData={getData} calendar={true} />
      </div>
      <div className="gridItem">
        {loading && (
          <CircularProgress
            sx={{ position: "absolute", top: "50%", left: "50%" }}
          />
        )}
        <DataGrid
          sx={{
            ".MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
            },
          }}
          rows={rowData}
          columns={columns}
          columnHeaderHeight={35}
          rowHeight={23}
          autoHeight={true}
          paginationMode="server"
          pageSizeOptions={[paginationModel.pageSize]}
          rowCount={rowCount}
          onPaginationModelChange={setPaginationModel}
          paginationModel={paginationModel}
          disableColumnMenu={true}
          disableSelectionOnClick
        />
      </div>

      <Warning
        open={openWarning}
        onHideWarning={closeWarning}
        warningMsg={errorMsg}
      ></Warning>
    </div>
  );
}
